var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtistDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    transform: "rotate(90)",
    x: 10,
    y: -23,
    width: 2,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    transform: "rotate(90)",
    x: 15,
    y: -20,
    width: 2,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    transform: "rotate(90)",
    x: 20,
    y: -22,
    width: 2,
    height: 13,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 30c7.732 0 14-6.268 14-14 0-7.732-6.268-14-14-14-7.732 0-14 6.268-14 14 0 7.732 6.268 14 14 14zm0 2c8.8366 0 16-7.1634 16-16 0-8.8366-7.1634-16-16-16-8.8366 0-16 7.1634-16 16 0 8.8366 7.1634 16 16 16z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistDetails);
export default __webpack_public_path__ + "static/media/artist-details.99e61f4c08a404d670926fe44eb2c932.svg";
export { ForwardRef as ReactComponent };